export default class Ingredient {
  constructor(lenis, productData = {}) {
    this.lenis = lenis;
    this.productData = productData;

    this.checkboxes = document.querySelectorAll('input[type="checkbox"][data-btn]');
    this.cards = document.querySelectorAll('.p-ingredient__menu_card[data-btn]');
    this.cardContainer = document.querySelector('.p-ingredient__menu');

    this.compareBtns = document.querySelectorAll('.js-compare_btn');
    this.counter = document.querySelector('.js-current_number');

    this.sidemenu = document.querySelector('.p-ingredient__side');
    this.mainmenu = document.querySelector('.p-ingredient__menu');

    this.scrollArea = document.querySelector('.js-scroll-area');

    this.selectedQueue = []; // 選択の記録

    if (!this.productData || Object.keys(this.productData).length === 0 || !this.checkboxes.length || !this.cards.length) {
      return;
    }

    this.init();
  }

  init() {
    this.initLenis();
    this.btnSelect();
    this.btnState();
    this.sideMenuFixed();
    this.compareCreate();
    this.SPmenuHandler();
    this.scrollbarHandler();
    this.resetMenus();
    this.resetQueue();
    this.updateLenisPrevent(this.scrollArea);
  }

  // カード選択時の処理（チェックと選択制御）
  btnSelect() {
    this.checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const btn = cb.dataset.btn;

        if (!cb.checked) {
          // チェックが外された場合、キューから削除
          this.selectedQueue = this.selectedQueue.filter(id => id !== btn);
        } else {
          // 選択数が3未満の時のみ追加可能
          if (this.selectedQueue.length >= 3) {
            // チェックを無効にする（実際のチェックも戻す）
            cb.checked = false;
            return;
          }
          this.selectedQueue.push(btn);
        }

        // カード選択表示更新
        const card = document.querySelector(`.p-ingredient__menu_card[data-btn="${btn}"]`);
        if (card) card.classList.toggle('is-selected', cb.checked);

        // 選択数に応じてチェックボックスの活性/非活性を更新
        const maxReached = this.selectedQueue.length >= 3;
        this.checkboxes.forEach(box => {
          if (!box.checked) {
            box.disabled = maxReached;
          }
        });

        this.updateCount();
        this.btnState();

        // カードホバー：最大数に達したら未選択カードを無効化
        this.cards.forEach(card => {
          const btn = card.dataset.btn;
          const cb = document.querySelector(`input[type="checkbox"][data-btn="${btn}"]`);
          if (!cb) return;

          if (!cb.checked && maxReached) {
            card.classList.add('is-disabled');
          } else {
            card.classList.remove('is-disabled');
          }
        });
      });
    });

    this.cards.forEach(card => {
      card.addEventListener('click', () => {
        const btn = card.dataset.btn;
        const cb = document.querySelector(`input[type="checkbox"][data-btn="${btn}"]`);
        if (!cb) return;
        cb.checked = !cb.checked;
        cb.dispatchEvent(new Event('change'));
      });
    });
  }


  // 比較ボタンの有効／無効を制御
  btnState() {
    const checkedCount = this.getCheckedCount();
    this.compareBtns.forEach(btn => {
      if (checkedCount < 2) {
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.classList.remove('is-disabled');
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  // 選択中の数値カウント表示更新
  updateCount() {
    const checkedCount = this.getCheckedCount();
    if (this.counter) {
      this.counter.textContent = checkedCount;
    }
  }
  // チェック済み数を返す
  getCheckedCount() {
    return Array.from(this.checkboxes).filter(cb => cb.checked).length;
  }

  // サイドメニューの固定
  sideMenuFixed() {
    const onScroll = () => {
      const menuRect = this.mainmenu.getBoundingClientRect();
      const sideHeight = this.sidemenu.offsetHeight;
      const scrollTop = window.scrollY;
      const fixedTop = 70;

      const menuTop = scrollTop + menuRect.top;
      const menuBottom = scrollTop + menuRect.bottom;

      if (scrollTop + fixedTop > menuTop && scrollTop + fixedTop + sideHeight < menuBottom) {
        this.sidemenu.classList.add('is-fixed');
        this.sidemenu.classList.remove('is-bottom');
      } else if (scrollTop + fixedTop + sideHeight >= menuBottom) {
        this.sidemenu.classList.remove('is-fixed');
        this.sidemenu.classList.add('is-bottom');
      } else {
        this.sidemenu.classList.remove('is-fixed', 'is-bottom');
      }
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  // SP時メニューの開閉制御
  SPmenuHandler() {
    const menuHandler = document.querySelector('.js-menu_handler');
    const sideWrap = document.querySelector('.p-ingredient__side_type_wrap');

    if (menuHandler && sideWrap) {
      menuHandler.addEventListener('click', () => {
        sideWrap.classList.toggle('is-open');
        menuHandler.classList.toggle('is-open');
      });
    }
  }

  //data-lenis-preventの付け替え処理
  updateLenisPrevent(scrollArea) {
    if (!scrollArea) return;

    const SP_BREAKPOINT = 768;
    const ACD_SELECTOR = '.js-acd_target';

    const applyLenisPrevent = () => {
      const isSP = window.innerWidth < SP_BREAKPOINT;

      if (isSP) {
        scrollArea.setAttribute('data-lenis-prevent', '');
        return;
      }

      // PCのみ以下を実行
      const anyPanelOpen = Array.from(document.querySelectorAll(ACD_SELECTOR)).some(el => {
        return el.getAttribute('aria-hidden') === 'false';
      });

      if (anyPanelOpen) {
        scrollArea.setAttribute('data-lenis-prevent', '');
      } else {
        scrollArea.removeAttribute('data-lenis-prevent');
      }
    };

    applyLenisPrevent();

    // リサイズに対応（SP切替対応）
    window.addEventListener('resize', applyLenisPrevent);

    // アコーディオン開閉監視
    const observer = new MutationObserver(applyLenisPrevent);
    document.querySelectorAll(ACD_SELECTOR).forEach(el => {
      observer.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }


  // スクロールバー表示判定
  scrollbarHandler() {
    if (!this.scrollArea) return;

    const checkScrollability = () => {
      const shouldShow = this.scrollArea.scrollHeight > this.scrollArea.clientHeight;
      this.scrollArea.classList.toggle('show-scrollbar', shouldShow);
    };

    //ResizeObserver ループエラー対策
    const safeCheckScrollability = () => {
      requestAnimationFrame(checkScrollability);
    };

    safeCheckScrollability();

    new ResizeObserver(safeCheckScrollability).observe(this.scrollArea);

    new MutationObserver(safeCheckScrollability).observe(this.scrollArea, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    window.addEventListener('resize', safeCheckScrollability);
  }



  // メニュー・アコーディオンの開閉状態をリセット
  resetMenus() {
    document.querySelectorAll('.js-acd_trigger.is-active').forEach(trigger => trigger.click());
    document.querySelector('.js-menu_handler')?.classList.remove('is-open');
    document.querySelector('.p-ingredient__side_type_wrap')?.classList.remove('is-open');
  }
  // チェック状態・選択状態・選択キューをリセット
  resetQueue() {
    this.checkboxes.forEach(cb => {
    cb.checked = false;
    cb.disabled = false;
    cb.dispatchEvent(new Event('change'));
    });

    this.cards.forEach(card => {
      card.classList.remove('is-selected');
      card.classList.remove('is-disabled');
    });

    this.selectedQueue = [];

    // 状態同期を明示的に呼び出す
    this.updateCount();
    this.btnState();
  }
  // Lenis初期化
  initLenis() {
    // if (this.lenis && typeof this.lenis.scrollTo === 'function') {
    //   this.lenis = lenis;
    // }
    if (!this.lenis || typeof this.lenis.scrollTo !== 'function') {
      console.warn('Lenis インスタンスが正しく渡されていません');
    }
  }

    
  // 比較表の生成
  compareCreate() {
    this.compareBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.resetMenus();

        const selectedBtns = Array.from(this.checkboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.dataset.btn);

        if (!selectedBtns.length) return;

        const variationSection = document.querySelector('.p-ingredient__variation');
        document.querySelector('.p-ingredient__compare')?.remove();

        const selectedProducts = selectedBtns.map(id => {
          const product = this.productData[id];
          if (!product) console.warn('製品データが見つかりません:', id);
          return product;
        });

        const nutritionKeys = [
          'エネルギー', 'タンパク質', '脂質', '炭水化物', '糖質', '食物繊維',
          '食塩相当量', 'カルシウム', '鉄', 'マグネシウム', 'リン',
          'ビタミンA', 'ビタミンB<sub>1</sub>', 'ビタミンB<sub>2</sub>', 'ビタミンB<sub>6</sub>', 'ビタミンB<sub>12</sub>',
          'ナイアシン', 'パントテン酸', '葉酸', 'ビタミンC', 'ビタミンD', 'ビタミンE', '(備考)カリウム'
        ];

        const headerRow = `
          <tr>
            <td></td>
            ${selectedProducts.map(p => `
              <th class="${p?.typeClass ?? ''}">
                <div class="package ${p?.typeClass ?? ''}">
                  ${p?.image_main ? `<img src="${window.gulpRelative + p.image_main}" alt="" loading="lazy">` : ''}
                </div>
                <p>${p?.compare_name || '-'}</p>
              </th>
            `).join('')}
          </tr>`;

        const bodyRows = nutritionKeys.map(key => {
          const displayKey = (key === '糖質' || key === '食物繊維') ? `- ${key}` : key;
          return `
            <tr>
              <th>${displayKey}</th>
              ${selectedProducts.map(p => `<td>${p?.nutrition?.[key] ?? '-'}</td>`).join('')}
            </tr>
          `;
        }).join('');

        const tableClass = selectedProducts.length === 2 ? 'is-2select' : '';

        const tableHTML = `
          <section class="p-ingredient__compare" id="compare">
            <div class="p-ingredient__compare_contents">
              <div class="sp-table-inner">
                <div class="p-ingredient__compare_contents_inner o-swipeHint-target">
                  <div class="o-swipeHint">
                    <img src="${window.gulpRelative + 'assets/image/common/swipe-icon.png'}" alt="スワイプで見る"  loading="lazy">
                  </div>
                  <table class="p-ingredient__compare_table ${tableClass}">
                    <thead>${headerRow}</thead>
                    <tbody>${bodyRows}</tbody>
                  </table>
                </div>
              </div>
              <div class="o-btn__wrap--center">
                <div class="o-btn o-btn--white is-link js-compare-reset">
                  <p>もう一度比較する</p>
                </div>
              </div>
            </div>
          </section>`;

        variationSection.insertAdjacentHTML('beforebegin', tableHTML);


        //比較のリセット
        document.querySelector('.js-compare-reset')?.addEventListener('click', (e) => {
          e.preventDefault();

          this.resetQueue();

          document.querySelector('.p-ingredient__compare')?.remove();
          this.resetMenus();

          if (this.lenis) {
            this.lenis.scrollTo(0, { offset: 0 });
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
        //リセット時にページTOPに戻る
        const header = document.querySelector('.l-header');
        const headerHeight = header ? header.offsetHeight : 0;
        const compareEl = document.getElementById('compare');

        if (this.lenis) {
          this.lenis.resize();
          requestAnimationFrame(() => {
            this.lenis.scrollTo(compareEl, { offset: -headerHeight });
          });
        } else {
          window.scrollTo({ top: compareEl.offsetTop - headerHeight, behavior: 'smooth' });
        }
      });
    });
  }
}


// ブラウザバック時にキャッシュ表示されていたら再読み込みしてリセット

function initIngredient() {
  new Ingredient();
}

document.addEventListener('DOMContentLoaded', initIngredient);

window.addEventListener('pageshow', function(event) {
  const navType = performance.getEntriesByType('navigation')[0]?.type;
  if ((event.persisted || navType === 'back_forward') && !sessionStorage.getItem('forceReloaded')) {
    sessionStorage.setItem('forceReloaded', 'true');
    location.reload();
  } else {
    sessionStorage.removeItem('forceReloaded');
    initIngredient();
  }
});
